import { Box, Button, Flex, HStack, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { fetchCompany, getUser } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { Link as DefaultLink } from 'react-router-dom';
import { FiEdit2 } from 'react-icons/fi';

export const ViewCompany = () => {
    
    const { company } = useAppSelector(state => state.companyReducer);
    const { company_id, name, phone, email, address } = company || {};

    const dispatch: AppDispatch = useAppDispatch();

    const fetchData = async () => {
        dispatch(getUser());
        await dispatch(fetchCompany());
    };

    useEffect(() => {
        fetchData();
    }, []);
    
    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Stack>
                    <HStack justifyContent={'space-between'} justifyItems={'center'} mb={3}>
                        <Heading size='md' mb={4}>Company Details</Heading>
                        <HStack>
                            <Button leftIcon={<FiEdit2 />} colorScheme='blue' variant='solid' as={DefaultLink} to='/company/add'>
                                Edit
                            </Button>
                        </HStack>
                    </HStack>
                    <Stack bg={'#FFFFFF'} borderRadius={6} p={4}>
                        <SimpleGrid columns={[1, null, 4]} spacing='40px'>
                            <Box w='100%'>
                                <Text fontWeight={'semibold'} mb={1}>Company ID</Text>
                                <Text color={'gray.500'}>{company_id}</Text>
                            </Box>
                            <Box w='100%'>
                                <Text fontWeight={'semibold'} mb={1}>Name</Text>
                                <Text color={'gray.500'} textTransform={'capitalize'}>{name}</Text>
                            </Box>
                            <Box w='100%'>
                                <Text fontWeight={'semibold'} mb={1}>Phone</Text>
                                <Text color={'gray.500'}>{phone}</Text>
                            </Box>
                            <Box w='100%'>
                                <Text fontWeight={'semibold'} mb={1}>Email</Text>
                                <Text color={'gray.500'}>{email}</Text>
                            </Box>
                            <Box w='100%'>
                                <Text fontWeight={'semibold'} mb={1}>Address</Text>
                                <Text color={'gray.500'}>{address}</Text>
                            </Box>
                        </SimpleGrid>
                    </Stack>
                </Stack>
            </Stack>
        </Flex>
    );
};